import { Icon } from '@aibees/shared/components';
import { useAdvanceTableContext } from '@aibees/shared/features/advance-table/context';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { SearchListSearchBarProps as Props } from './types';

export const SearchListSearchBar = memo(
  ({ className, filters, setFilter }: Props) => {
    const { config } = useAdvanceTableContext();

    return (
      <Styled.Wrapper className={classnames('SearchListSearchBar', className)}>
        <Styled.Input
          autoComplete="off"
          value={filters.name}
          fullWidth
          InputProps={{
            endAdornment: (
              <Styled.SearchButton variant="contained" size="large">
                Search
              </Styled.SearchButton>
            ),
            startAdornment: <Icon name="search" />,
          }}
          onChange={(v) => setFilter('name', v.currentTarget.value)}
          placeholder={
            (config?.metadata?.filters?.placeholder as string) ?? undefined
          }
        />
      </Styled.Wrapper>
    );
  }
);

SearchListSearchBar.displayName = 'SearchListSearchBar';
